import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { FacilityDataModel } from '../models/facility-config.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AlertActions,
  WebSocketService,
} from 'src/app/shared/services/web-socket.service';
import { Apollo } from 'apollo-angular';
import {
  GET_ZONE_CONFIGURATIONS_BY_FACILITY,
  SYNC_ZONES_WITH_STATIONS,
} from '../queries/facility-config.queries';
import { MutationResult, UpdateResult } from 'src/app/shared/graph-queries/types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacilityConfigService {
  private facilityData = new BehaviorSubject<FacilityDataModel[]>([]);
  facilityData$ = this.facilityData.asObservable();

  private hasConfiguration = new BehaviorSubject<boolean>(false);
  hasConfiguration$ = this.hasConfiguration.asObservable();

  public activeStationIds = new BehaviorSubject<any[]>([]);
  activeStationIds$ = this.activeStationIds.asObservable();

  public currentStationList = new BehaviorSubject<any[]>([]);
  currentStationList$ = this.currentStationList.asObservable();

  public allRequired = new BehaviorSubject<boolean>(false);
  allRequired$ = this.allRequired.asObservable();

  public configurationWarning = new BehaviorSubject<boolean>(false);
  configurationWarning$ = this.configurationWarning.asObservable();

  constructor(private apolloClient: Apollo) {}

  setFacilityData(data: FacilityDataModel[]) {
    this.facilityData.next(data);
  }

  getFacilityData(): FacilityDataModel[] {
    return this.facilityData.getValue();
  }

  setHasConfiguration(hasConfig: boolean) {
    this.hasConfiguration.next(hasConfig);
  }

  getHasConfiguration(): boolean {
    return this.hasConfiguration.getValue();
  }

  setActiveStationIds(stations: any[]) {
    this.activeStationIds.next(stations);
  }

  getActiveStationIds(): any[] {
    return this.activeStationIds.getValue();
  }

  setCurrentStationList(stations: any[]) {
    this.currentStationList.next(stations);
  }

  getCurrentStationList(): any[] {
    return this.currentStationList.getValue();
  }

  updateAllRequired(allReq: boolean) {
    this.allRequired.next(allReq);
  }

  getAllRequired(): boolean {
    return this.allRequired.getValue();
  }

  setConfigurationWarning(status: boolean) {
    this.configurationWarning.next(status);
  }

  getConfigurationWarning(): boolean {
    return this.configurationWarning.getValue();
  }

  getConfigurationData(userFacility: string): void {
    this.apolloClient
      .query({
        query: GET_ZONE_CONFIGURATIONS_BY_FACILITY,
        variables: { userFacility },
        fetchPolicy: 'no-cache',
      })
      .subscribe((response: any) => {
        this.facilityData.next(response.data.GetZoneConfigurationsByFacility);
      });
  }

  saveFacilityConfig(facilityData: any): Observable<UpdateResult> {
    return this.apolloClient
      .mutate<UpdateResult>({
        mutation: SYNC_ZONES_WITH_STATIONS,
        variables: {
          payload: JSON.stringify(facilityData),
        },
      })
      .pipe(
        map((result: MutationResult) => {
          return result.data.SyncZonesWithStations as UpdateResult;
        })
      );
  }
}
